import { client } from "utils";

export const getAuthPolicyRequest = () => client.get("auth-policy");

export const getUserRequest = () => client.get("iam");

export const logOutRequest = () => client.get("logout");

export const storeShortUrlRequest = (data) => client.post("short-urls", data);

export const getShortUrlRequest = (id) => client.get(`short-url/${id}`);